

















import Vue from 'vue';

export default Vue.extend({
	name: 'Home',

	beforeCreate() {
		this.$router.push({ name: 'leagues' });
	},
});
